import classnames from "classnames"
import { useAPI } from "hooks/useAPI"
import PropTypes from "prop-types"
import React from "react"
import { Badge, Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const StatusEsteira = props => {
  const { cardsNumber, reportId } = props

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )
  const { payload, isLoading } = useAPI(
    reportId,
    filtrosSelecionados,
    fetchReports
  )

  const report = payload || Array(cardsNumber).fill({})
  const { total, columns } = report

  return (
    <Card>
      <CardHeader className="bg-transparent border-bottom">
        <h4 className="mb-0">Status</h4>
      </CardHeader>
      <CardBody>
        <Row>
          <Col
            sm={3}
            className={classnames({
              "border-end": true,
              placeholderGlow: isLoading,
            })}
          >
            {!isLoading && (
              <React.Fragment>
                <h1 className="fw-semibold display-4 mb-0">
                  {total ? Intl.NumberFormat("pt-BR").format(total) : 0}
                </h1>
                <p className="text-muted fw-medium">Total</p>
              </React.Fragment>
            )}
            {isLoading && (
              <React.Fragment>
                <h1 className="fw-semibold display-4 mb-0">
                  <span className="placeholder col-6"></span>
                </h1>
                <p className="text-muted fw-medium">Total</p>
              </React.Fragment>
            )}
          </Col>
          <Col>
            <Row className="pt-2">
              {!isLoading &&
                columns?.map((cl, idx) => {
                  return (
                    <Col key={idx}>
                      <h1 className="fw-semibold display-7 mb-0">
                        {cl?.percent}
                      </h1>
                      <p className="text-muted fw-medium mb-0">{cl?.label}</p>
                      {cl?.inside ? (
                        <React.Fragment>
                          <Badge className="fs-6 me-1" pill color="success">
                            {cl?.inside}
                          </Badge>
                          <Badge className="fs-6 me-1" pill color="danger">
                            {cl?.outside}
                          </Badge>
                        </React.Fragment>
                      ) : (
                        <p className="mb-0">
                          <Badge className="fs-6" pill color={cl?.status}>
                            {cl?.value}
                          </Badge>
                        </p>
                      )}
                    </Col>
                  )
                })}
              {isLoading &&
                Array(6)
                  .fill({})
                  ?.map((cl, idx) => {
                    return (
                      <Col className="placeholderGlow" key={idx}>
                        <h1 className="fw-semibold display-7 mb-0">
                          <span className="placeholder col-3"></span>
                        </h1>
                        <p className="text-muted fw-medium mb-0">
                          <span className="placeholder col-7"></span>
                        </p>
                        <p className="mb-0">
                          <span className="placeholder col-5"></span>
                        </p>
                      </Col>
                    )
                  })}
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

StatusEsteira.propTypes = {
  cardsNumber: PropTypes.number,
  reportId: PropTypes.number,
}

export default StatusEsteira
